import { render } from "./ComingSoonModal.vue?vue&type=template&id=736421ef&scoped=true"
import script from "./ComingSoonModal.vue?vue&type=script&lang=js"
export * from "./ComingSoonModal.vue?vue&type=script&lang=js"

import "./ComingSoonModal.vue?vue&type=style&index=0&id=736421ef&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-736421ef"]])

export default __exports__